/* GSC fix: remove orphaned Judge.me AggregateRating microdata that lacks a
   parent Product (Google error: Missing field "itemReviewed").
   Keeps the visible star badges (separate DOM node) and leaves valid
   product-page JSON-LD untouched. Applies on all pages; a rating is only
   kept if nested inside a real Product itemscope. */
(function () {
  function stripOrphanRichSnippets() {
    try {
      var nodes = document.querySelectorAll('.jdgm-prev-badge__rich-snippet');
      nodes.forEach(function (el) {
        var insideProduct = el.closest && el.closest('[itemtype*="Product"]');
        if (!insideProduct && el.parentNode) {
          el.parentNode.removeChild(el);
        }
      });
    } catch (e) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', stripOrphanRichSnippets);
  } else {
    stripOrphanRichSnippets();
  }
  // Insurance in case Judge.me re-injects badges after initial load.
  try {
    var mo = new MutationObserver(function () { stripOrphanRichSnippets(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 10000);
  } catch (e) {}
})();